<div class="row" >
  <div class="col-6" style="background-color: greenyellow">
    <div class="row">
      <h3 class="col-12">
          <div class="icon-bg">
              <mat-icon style="height:100%; width:100%;">chat_bubble_outline</mat-icon>
          </div>
          Nous contacter
        </h3>
        <p class="col-12">
            Service clients : +331 86 86 85 85<br/>
            <span>De 9h à 12h et de 14h à 18h du lundi au vendredi</span><br/>
            Assistance technique 24/7<br/>
            <span>Numéro disponible sur votre confirmation de réservation</span><br/>
        </p>
    </div>
  </div>
</div>